<div
  class="card-shadow px-4 py-6 md:p-4 rounded-lg border border-solid border-[#C9CBCE] cursor-pointer flex items-center justify-center"
>
  @if (displayImage(); as imageUrl) {
    <img
      [src]="imageUrl"
      [alt]="alt()"
      class="size-[4rem] md:size-[4.5rem] rounded-full object-cover"
      (error)="onImageError()"
    />
  } @else {
    <div
      class="size-[4rem] md:size-[4.5rem] rounded-full bg-[#EEEEEF] flex items-center justify-center text-[#8A8E94]"
      role="img"
      [attr.aria-label]="alt()"
      data-testid="brand-image-fallback"
    >
      <svg aria-hidden="true" width="32" height="32" viewBox="0 0 24 24" fill="none">
        <path
          d="M5 8.5 7 4h10l2 4.5M5 8.5h14M5 8.5v10.25c0 .69.56 1.25 1.25 1.25h11.5c.69 0 1.25-.56 1.25-1.25V8.5"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path d="M9 20v-5h6v5" stroke="currentColor" stroke-width="1.5" />
      </svg>
    </div>
  }
</div>
